import "./Instructions.scss";
import { useGlobalState } from "../../context/GlobalStateContext";
import RU1 from "@assets/img/OneIdRU/1.JPG";
import RU2 from "@assets/img/OneIdRU/2.JPG";
import RU3 from "@assets/img/OneIdRU/3.JPG";
import RU4 from "@assets/img/OneIdRU/4.JPG";
import RU5 from "@assets/img/OneIdRU/5.JPG";
import RU6 from "@assets/img/OneIdRU/6.JPG";
import RU7 from "@assets/img/OneIdRU/7.JPG";
import RU8 from "@assets/img/OneIdRU/8.JPG";

import UZ1 from "@assets/img/OneIdUZ/1.JPG";
import UZ2 from "@assets/img/OneIdUZ/2.JPG";
import UZ3 from "@assets/img/OneIdUZ/3.JPG";
import UZ4 from "@assets/img/OneIdUZ/4.JPG";
import UZ5 from "@assets/img/OneIdUZ/5.JPG";
import UZ6 from "@assets/img/OneIdUZ/6.JPG";
import UZ7 from "@assets/img/OneIdUZ/7.JPG";
import UZ8 from "@assets/img/OneIdUZ/8.JPG";
import { useState } from "react";

const ruScreens = [RU1, RU2, RU3, RU4, RU5, RU6, RU7, RU8];
const uzScreens = [UZ1, UZ2, UZ3, UZ4, UZ5, UZ6, UZ7, UZ8];
const Instructions = () => {
  const { language } = useGlobalState();
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <div className="instructions">
      <div className="instructions__container">
        {language === "ru" ? (
          <>
            <h1 className="instructions__title">
              Важно для пользователей Paylater
            </h1>

            <div className="instructions__text">
              <h2>Проверьте доступ Paylater в OneID</h2>

              <p>
                Если доступ к персональным данным в OneID отключён, оформление
                рассрочки и другие операции могут работать с задержками.
              </p>

              <h3>Что может быть недоступно:</h3>

              <ul>
                <li>оформление рассрочки</li>
                <li>заявка на лимит</li>
                <li>подтверждение личности</li>
                <li>подписание договоров</li>
              </ul>

              <h3>Чтобы предоставить доступ Paylater:</h3>

              <ol>
                <li>Скачайте приложение OneID</li>

                <li>
                  После входа в систему перейдите в раздел «Управление» в
                  главном меню
                </li>
                <li>
                  Подтвердите ознакомление с предупреждением и активируйте
                  услугу
                </li>
                <li>Напротив Paylater нажмите на значок замка</li>
                <li>Предоставьте доступ к вашим данным</li>
                <li>
                  Напротив Kredit Axborot Tahlily Markazi нажмите на значок
                  замка
                </li>
                <li>Предоставьте доступ к вашим данным</li>
              </ol>

              <p className="instructions__footer">
                Функция повышает безопасность и обеспечивает быструю работу
                сервиса.
              </p>
            </div>
            <div className="instructions__screens">
              {(language === "ru" ? ruScreens : uzScreens).map((src, index) => (
                <div
                  key={index}
                  className="instructions__screen"
                  onClick={() => setActiveIndex(index)}
                >
                  <img src={src} alt={`OneID step ${index + 1}`} />
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <h1 className="instructions__title">
              Paylater foydalanuvchilari uchun muhim!
            </h1>

            <div className="instructions__text">
              <h2>OneID’da Paylater’ga kirish huquqini tekshiring</h2>

              <p>
                Agar OneID’da shaxsiy ma’lumotlarga ruxsat o‘chirilgan bo‘lsa,
                muddatli to'lovni rasmiylashtirish va boshqa amallar kechikib
                ishlashi mumkin.
              </p>

              <h3>Quyidagi xizmatlar vaqtincha mavjud bo‘lmasligi mumkin:</h3>

              <ul>
                <li>bo‘lib to‘lashni rasmiylashtirish</li>
                <li>limit uchun ariza berish</li>
                <li>shaxsni tasdiqlash</li>
                <li>shartnomalarni imzolash</li>
              </ul>

              <h3>Paylater uchun ruxsat berish tartibi:</h3>

              <ol>
                <li>OneID ilovasini yuklab oling</li>

                <li>
                  Tizimga kirgach, asosiy menyudagi "Boshqarish" bo‘limiga
                  o‘ting
                </li>
                <li>
                  Ogohlantirish maʼlumotlari bilan tanishganingizni tasdiqlang
                  va xizmatni faollashtiring
                </li>
                <li>Roʻyxatda Paylater qarshisidagi qulf belgisini bosing</li>
                <li>Maʼlumotlaringizdan foydalanishga ruxsat bering</li>
                <li>
                  Roʻyxatda Kredit Axborot Tahlily Markazi qarshisidagi qulf
                  belgisini bosing
                </li>
                <li>Maʼlumotlaringizdan foydalanishga ruxsat bering</li>
              </ol>

              <p className="instructions__footer">
                Bu funksiya xavfsizlikni oshiradi va xizmatning tez ishlashini
                ta’minlaydi.
              </p>
            </div>
            <div className="instructions__screens">
              {(language === "ru" ? ruScreens : uzScreens).map((src, index) => (
                <div
                  key={index}
                  className="instructions__screen"
                  onClick={() => setActiveIndex(index)}
                >
                  <img src={src} alt={`OneID step ${index + 1}`} />
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      {activeIndex !== null && (
        <div className="instructions__lightbox">
          <button
            type="button"
            className="instructions__lightbox-close"
            onClick={() => setActiveIndex(null)}
          >
            ✕
          </button>

          <img
            src={(language === "ru" ? ruScreens : uzScreens)[activeIndex]}
            alt={`OneID full screen ${activeIndex + 1}`}
          />
        </div>
      )}
    </div>
  );
};

export default Instructions;
